export default __webpack_public_path__ + "static/media/perfect-day.5156c281.svg";